<template>
  <div id="Program-styles-program Program-styles-desktop">

    <div v-if="eventNotfound" class="alert alert-info">
      {{ t.error.notfound_fixture }}
    </div>

    <div class="col-12 text-center">
     <!-- <spinalLoader class="mt-5" v-show="loader" /> !-->
    </div>

    <div class="Sport-styles-sport-container pb-3" v-if="events.length">
      <template v-for="(l, inx) in events">

            <SportRow :sport="l" :extendedMarkets="extendedMarkets" :list="filter.list" :onLive="onLive" v-if="l.type === 'sport'"/>
            <CompetitionRow :competition="l" v-if="l.type === 'competition'" :list="filter.list" :onLive="onLive" />
            <div class="EventDateHeader-styles-event-date-header" v-if="!onLive && l.type === 'timeperiod'">{{ l.period | moment('D MMMM dddd', session.timezone) }}</div>
            <RegionRow :sticky="sticky" :region="l" :extendedMarkets="extendedMarkets" :onLive="onLive" v-if="l.type === 'region' && !hideTitles"/>
            <MatchRow class="r-event" v-if="l.type === 'event'" :match.sync="l" :sport="l.sport" :region="l.region" :extendedMarkets="extendedMarkets"
                      :indx="inx"
                      :i="inx"
                      :selectedOdds="selectedOdds"
                      :list="filter.list"
                      :m="l.matchId" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" />

      </template>
    </div>

    <div class="loadmore" v-waypoint="{ active: true, callback: onWaypointLoadMore, options: intersectionOptions }"></div>
    <paginate v-if="pagination.pageCount && !hidePagination"
              :page-count="pagination.pageCount"
              :page-range="pagination.pageRange"
              :force-page="(pagination.current-1)"
              :initialPage="(pagination.current-1)"
              :margin-pages="2"
              :click-handler="onChangePage"
              :prev-text="t.previous"
              :next-text="t.next"
              :container-class="'pagination float-right'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'">
    </paginate>

  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import ContentPlaceholder from 'vue-content-placeholder'
import betSlip from '@/mixins/betSlip'
import BetSlipC from '@/components/sportsbook/BetSlip';
import odd from '@/components/sportsbook/odd';
import sportIcon from '@/components/ui/asset/sportIcon';
import MatchRow from '@/components/sportsbook/MatchRow'
import favorites from '@/mixins/favorite'
import spinalLoader from '@/components/ui/loader/spinalLoader'
import SportRow from '@/components/sportsbook/SportRow'
import RegionRow from '@/components/sportsbook/RegionRow'
import eventSearch from '@/components/sportsbook/widget/eventSearch';
import CompetitionRow from '@/components/sportsbook/CompetitionRow';
import fixture from '../../mixins/fixture';

export default {
  name: 'matches',
  components: {eventSearch, Paginate, BetSlipC, odd, sportIcon, MatchRow, spinalLoader, SportRow,CompetitionRow, RegionRow},
  mixins: [betSlip,favorites,fixture],
  props: {
    filter: {},
    onLive: false,
    extendedMarkets: {
      default: true
    },
    hidePagination: {
      default: false
    },
    hideTitles: false,
    pp: 55,
    list: false,
  },
  data() {
    return {
      noMore: false,
      previousStateRequest: null,
      previousRequest: null,
      xhr_request: [],
      activeEvents: [],
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
      },
      loader: null,
      t: this.$root.t,
      newevents: [],
      virtualEvents: [],
      events: [],
      selectedOdds: [],
      eventNotfound: false,
      selectedEventDate: false,
      activeEventsKeys: [],
      activeEventMap: [],
      session: session,
      pagination: [],
      page: 1,
      changedOdd: [],
      odd: [],
      matchId: 0,
      matchName: null,
      selectedMatch: null,
      eventIds: null,
      upcoming: null,
      scrolled: false,
      lockMatchUpdate: false,
      sticky: true,
      selectedRegions: [],
      selectedCompetitions: [],
      placeholderRows: [

        {
          height: '1rem',
          boxes: [[0, '100%']]
        },

      ],
      showOnlyFavorites: false,
      favoriteList: [],
      disableSport: false,
      noScroll: false
    }
  },
  watch: {
    'showOnlyFavorites'(v) {
      this.events = null;

      if(!v)
        this.$bus.$emit('ListOnlyFavorites', null);
    },
    '$store.state.betslip' (m) {
              this.$set(this, 'bets', m)
    },
    '$store.state.updateMarket' (m) {
        /*

      m.forEach( (market,k) => {

          let findEvent = this.virtualEvents.find(o => o.id == market.eventId);
          let ress = this.virtualEvents.indexOf(findEvent);

          if( ress > -1 ) {

            let findIndex = findEvent.markets.findIndex(o => o.id == market.id);
            if (findIndex > -1) {
              if (market.disabled){
                findEvent.markets.splice(findIndex, 1)
              }else {
                findEvent.markets[findIndex] = market
              }
            }else {
              findEvent.markets.push(market)
            }

            this.virtualEvents[ress] = findEvent
            //this.$set(this, 'events', this.compileList(this.virtualEvents));
          }

        if (this.market && this.market.id == market.id){
          market.selections.forEach( (v,k) => {
            let obj = this.market.odd.find(o => o.id === v.id);
            obj.odd = v.value
            obj.active = !v.isDisabled
          })
        } 
      }) */
    },
    '$store.state.updateMatch' (m) {
      m.forEach((d,k) => {
          d.goal = 0;
          let findEvent = this.virtualEvents.find(o => o.id == d.id);
          let ress = this.virtualEvents.indexOf(findEvent);

          if( ress > -1 ) {

            let findEvent = this.events.find(o => o.id == d.id);

            if (findEvent) {

              findEvent.resultName = d.result.name
              findEvent.periodTime = d.periodTime
              findEvent.odds = this.marketCompile(d)

            }
             // var markets = this.virtualEvents[ress].markets
             // this.virtualEvents[ress] = d
             // this.virtualEvents[ress].markets = markets
            ///  this.$set(this, 'events', this.compileList(this.virtualEvents));
          }else {
            if (d.onLive && d.periodTime > 0 && this.onLive && this.filter.sport === d.sport.id){
                this.virtualEvents.push(d)
                this.events = this.compileList(this.virtualEvents);
                this.$set(this, 'events', this.events);
            }
          }

          if( ress > -1 && d.result.name === 'Ended' ) {
            setTimeout(() => {
              let indx = this.virtualEvents.findIndex(o => o.id === d.id);
              if (indx > 0){
                this.virtualEvents.splice(indx, 1)
                this.events = this.compileList(this.virtualEvents);
                this.$set(this, 'events', this.events);
              }
 
            }, 5000)
          }
      });
    },
    '$route.params'() {
      //this.events = null;
      //this.fetchEvents();
    },
    'filter'() {

      this.noScroll = true;
      //this.events = [];
      this.noMore = false;
      this.page = 1;
      this.virtualEvents = [];
      this.fetchEvents();
    },
    'matchId'(o, n) {

      if (n == 0) {

      }

      if (o) {
      }

    }
  },
  beforeDestroy() {
    clearInterval(this.EventInterval);
   clearInterval(this.EventInterval2);
   // clearInterval(this.EventInterval3);

    this.abortAllRequest();
  },
  mounted() {

    var self = this;
    this.syncSelectedBets();

    if(this.filter.onLive){
      //clearInterval(this.EventInterval2);
      clearInterval(this.EventInterval3);
      this.EventInterval2 = setInterval(this.fetchLatestBets, 5000);
      //this.EventInterval3 = setInterval(this.fixtureState, 3000);
      //this.EventInterval = setInterval(this.fetchEvents, 100000);
    }

    if(this.filter.onLive || this.filter.upcoming)
      this.fetchEvents();

  },
  methods: {
    syncSelectedBets (event = false) {
      this.$getItem('selectedBets', (key, value) => {

        this.selectedOdds = value;

        this.$set(this, 'selectedOdds', this.selectedOdds);
      });

    },
    showFavorites () {

    },
    onWaypointLoadMore({el, going, direction}) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        //console.log('waypoint going in!');

        if(this.filter.loadmore && !this.onLive)
          this.fetchEvents()
      }

      if (going === this.$waypointMap.GOING_OUT) {
        //console.log(direction)

      }

      if (direction === this.$waypointMap.DIRECTION_TOP) {
        //console.log('waypoint going top!')
      }
    },
    onWaypoint({el, going, direction}) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        //console.log('waypoint going in!');

        this.activeEvents.remByVal(el.getAttribute('m'))
        this.activeEvents.push(el.getAttribute('m'));

        this.activeEventsKeys.push(el.getAttribute('i'));
        //console.log(`#${el.getAttribute('m')}`)
        el.classList.toggle('active', this.$waypointMap.GOING_IN === going)
      }

      if (going === this.$waypointMap.GOING_OUT) {
        //console.log(direction)
        this.activeEvents.remByVal(el.getAttribute('m'))
        this.activeEventsKeys.remByVal(el.getAttribute('i'))
      }

      if (direction === this.$waypointMap.DIRECTION_TOP) {
        //console.log('waypoint going top!')
      }
    },
    onChangePage(page) {
      this.pagination.current = page;
      this.page = page;

        this.fetchEvents();

      //window.scroll(0, 0);
    },
    fixtureState () {
      this.$http.get(bsapi + 'api/v1/fixture/state/'+this.currentFixtureState, {
        before(request) {

          // abort previous request, if exists
          if (this.previousStateRequest) {
            this.previousStateRequest.abort();

          }

          // set previous request on Vue instance
          this.previousStateRequest = request;
          this.xhr_request.push(request);
        }
      }).then(response => {
        // get body data

        if(response.body)

          Object.values(response.body).forEach((v) => {

            this.currentFixtureState = v.state;

            let findEvent = false;

            if(this.events)
              findEvent = this.events.find(o => o.eid === v.eventId);

            if(findEvent){

              let ress = this.events.indexOf(findEvent);

              if(v.command === 'update_market' || v.command === 'insert_market' || v.command === 'insert_market')
                this.events[ress].odds[v.dataId] = v.data;

              if(v.command === 'remove_market')
                delete this.events[ress].odds[v.dataId];

              if(v.command === 'update_match'){

                if(typeof this.events[ress] !== 'undefined'){
                  v.data.odds = this.events[ress].odds;
                  this.events[ress] = v.data;
                  this.events[ress].data = v.data.data;
                  this.$set(this.events, ress, v.data);
                }else {

                  this.events.push(v.data);
                  this.$set(this, 'events', v.data);
                }

                //console.log(findEvent.name);
                //console.log(v.data);

              }


              if(v.command === 'suspend_match'){
                this.events[ress].isSuspended = true;
              }



              //this.$set(this.events, ress, findEvent);

              //console.log(findEvent.name);
              //console.log(v.eventId + ' - '+v.data.market.name );
              //console.log(v.data);
              //console.log(this.events[ress].odds[v.dataId]);


              //let ress = this.events.indexOf(findEvent);
              //this.$set(this.events, ress, d);
            }

            //this.$bus.$emit('fixture_state_'+v.eventId, v);
          });


      }, response => {


      })
    },
    abortAllRequest () {
      this.xhr_request.forEach((r,v) => {
        r.abort();
      })
    },
    fetchLatestBetsOld() {
      //th.$bus.$emit('updatedOdd', payload);

      if(!this.lockMatchUpdate){

        this.$http.get(bsapi + 'matches.aspx', {
          params: {
            match: this.activeEvents,
            app: this.$root.app.id,
            uid: this.$root.session.uid,
            onLive: 1,
            onlyList: 1,
            t: Math.floor(Date.now() / 1000),
            ro: 1
          }
        }).then(response => {
          // get body data
          if (response.body) {
            /*
            response.body.forEach(data => {
              this.$bus.$emit('updatedOdd', data);
            }); */

            response.body.result.forEach((d,k) => {

              let findEvent = this.events.find(o => o.id === d.id);
              let ress = this.events.indexOf(findEvent);
              this.$set(this.events, ress, d);
            });

            this.syncSelectionClass();

          }

        }, response => {

        })
      }
    },
    fetchLatestBets() {
      //th.$bus.$emit('updatedOdd', payload);

      if(this.onLive && !this.lockMatchUpdate && this.activeEvents.length > 0){

       this.fetchLiveEvents({
          event: this.activeEvents.join(','),
          app: this.$root.app.id,
          uid: this.$root.session.uid,
          onLive: 1,
          onlyList: 1,
          t: Math.floor(Date.now() / 1000),
          ro: 1,
          locale: window.locale
        }).then(response => {
          // get body data
          if (response.body) {
            /*
            response.body.forEach(data => {
              this.$bus.$emit('updatedOdd', data);
            }); */

            this.compileList(response.body.result).forEach((d,k) => {

              let findEvent = this.events.find(o => o.id === d.id);
              let ress = this.events.indexOf(findEvent);
              this.$set(this.events, ress, d);
            });

            this.syncSelectionClass();

          }

        }, response => {

        })
      }
    },
    async fetchEvents() {

      var Competitions = this.filter.competitions;
     // if(window.windowLiveCache && this.filter.isLive)
       // this.events = window.windowLiveCache;

      if(window.windowFocused > 0 && !this.noMore){
        this.eventNotfound = false;
        //this.lockMatchUpdate = true;
        this.disableSport = true

        if(this.$route.name === 'myFavorites' || this.$route.query.favOnly) {
          Competitions = []
          await this.$http.get(api+ 'api/v2/favs').then((v) => {
                v.body.result.forEach((v) => {
                    Competitions.push(v.data)
                })
            })
        }
        //this.$bus.$emit('globalLoader', 1);
        this.loader = (this.loader === null) ? true : false;
        this.fetchLiveEvents({
            //per_page: (this.filter.per_page) ? this.filter.per_page : 100,
            sport: (this.$route.query.sport) ? this.$route.query.sport : this.filter.sport,
            region: (this.filter.regions) ? this.filter.regions.join(',') : null,
            competition: (Competitions) ? Competitions.join(',') : null,
            page: (this.onLive) ? 1 : this.page,
            withBets: null,
            upcoming: (this.$route.query.upcoming) ? this.$route.query.upcoming : this.filter.upcoming,
            highlighted: this.filter.highlighted,
            match: this.eventIds,
            onLive: (this.onLive) ? 1 : '',
            isLive: (this.filter.isLive) ? 1 : '',
            app: this.$root.app.id,
            uid: this.$root.session.uid,
            onlyList: 'row',
            a: 1,
            locale: window.locale,
            listFavourites: this.listFavourites,
            listCompetitionFavourites: (this.$route.name === 'myFavorites' || this.$route.query.favOnly) ? 1 : this.$store.state.listCompetitionFavourites,
            t: (this.listFavourites) ? Math.floor(Date.now() / 1000) : null
          }).then(response => {
          // get body data

          if(!response.body.result){
            this.loader = false;
            this.pagination = false;

            return false;
          }

          //this.$store.commit("updateSport", response.body.result.sport);

          this.syncSelectionClass();
          this.disableSport = false;

            if(!this.scrolled && this.page > 1) {
              setTimeout(() => {
                var h = document.querySelector('.Sport-styles-sport-container').offsetHeight
                //window.scrollTo(0, (h / 2));
              }, 500);
              this.scrolled = true;

            }

          if(response.body.result.sport){
            this.events = Object.values(response.body.result.sport);
            window.windowLiveCache = response.body.result;
          }else {

            if(!this.onLive){
              if(response.body.result.length === 0){
                this.noMore = true;
              }else {
                  this.page += 1;
              }
            }

            window.windowLiveCache = response.body.result;

            if(this.onLive)
              this.virtualEvents = []

              response.body.result.forEach((v) => {

              let findEvent = this.virtualEvents.find(o => o.id === v.id);
              let indx = this.virtualEvents.indexOf(findEvent);

              if(indx >= 0){
                  this.$set(this.virtualEvents, indx, v);
              }else {
                  this.virtualEvents.push(v)
              }
            
              })

            this.events = this.compileList(this.virtualEvents);
            
            setTimeout(() => {
              this.$store.commit("updateSport", Math.floor(Date.now() / 1000));
            }, 1000)


          }

          //this.syncSelectedBets();
          //setTimeout(() => {
          //  this.fetchLatestBets();
          //}, 500);

          //this.pagination = response.body.pagination;
          this.loader = false;
          this.eventNotfound = false;
          this.lockMatchUpdate = false;
          //this.$bus.$emit('globalLoader', 0);

          //To(0,window.pageYOffset - 500); 


        }, response => {
          // error callback
          //this.$bus.$emit('globalLoader', 0);
          this.loader = false;
        })
      }

    },

    fetchEventsOld() {

      if(window.windowLiveCache && this.filter.isLive)
        this.events = window.windowLiveCache;

      if(window.windowFocused > 0){
        this.eventNotfound = false;
        this.lockMatchUpdate = true;
        this.disableSport = true

        //this.$bus.$emit('globalLoader', 1);
        this.loader = (this.loader === null) ? true : false;
        this.$http.get(bsapi + 'matches.aspx', {
          params: {
            per_page: (this.filter.per_page) ? this.filter.per_page : 100,
            sport: (this.$route.query.sport) ? [this.$route.query.sport] : [this.filter.sport],
            region: this.filter.regions,
            competition: this.filter.competitions,
            page: (this.$route.query.page) ? this.$route.query.page : this.page,
            withBets: null,
            upcoming: (this.$route.query.upcoming) ? this.$route.query.upcoming : this.filter.upcoming,
            highlighted: this.filter.highlighted,
            match: this.eventIds,
            onLive: (this.onLive) ? 1 : '',
            isLive: (this.filter.isLive) ? 1 : '',
            app: this.$root.app.id,
            uid: this.$root.session.uid,
            onlyList: 'row',
            listFavourites: this.listFavourites,
            listCompetitionFavourites: (this.$route.name === 'myFavorites' || this.$route.query.favOnly) ? 1 : this.$store.state.listCompetitionFavourites,
            t: (this.listFavourites) ? Math.floor(Date.now() / 1000) : null
          },
          before(request) {

            // abort previous request, if exists
            if (this.previousRequest) {
              this.previousRequest.abort();
            }

            // set previous request on Vue instance
            this.previousRequest = request;
            this.xhr_request.push(request);
          }

        }).then(response => {
          // get body data

          if(!response.body.result){
            this.loader = false;
            this.pagination = false;

            return false;
          }

          this.$store.commit("updateSport", response.body.result.sport);

          this.syncSelectionClass();
          this.disableSport = false;

          if(!this.scrolled) {
            setTimeout(() => {
              window.scrollTo(0, 1);
            }, 500);
            this.scrolled = true;
          }

          if(response.body.result.sport){
            this.events = Object.values(response.body.result.sport);
            window.windowLiveCache = response.body.result;
          }else {
            window.windowLiveCache = response.body.result;
            this.events = response.body.result;
          }

           this.fetchLiveEvents({
            //per_page: (this.filter.per_page) ? this.filter.per_page : 100,
            per_page: 1,
            sport: (this.$route.query.sport) ? this.$route.query.sport : this.filter.sport,
            region: (this.filter.regions) ? this.filter.regions.join(',') : null,
            competition: (this.filter.competitions) ? this.filter.competitions.join(',') : null,
            page: (this.$route.query.page) ? this.$route.query.page : this.page,
            withBets: null,
            upcoming: (this.$route.query.upcoming) ? this.$route.query.upcoming : this.filter.upcoming,
            highlighted: this.filter.highlighted,
            match: this.eventIds,
            onLive: (this.onLive) ? 1 : '',
            isLive: (this.filter.isLive) ? 1 : '',
            app: this.$root.app.id,
            uid: this.$root.session.uid,
            onlyList: 'row',
            locale: 'tr',
            listFavourites: this.listFavourites,
            listCompetitionFavourites: (this.$route.name === 'myFavorites' || this.$route.query.favOnly) ? 1 : this.$store.state.listCompetitionFavourites,
            t: (this.listFavourites) ? Math.floor(Date.now() / 1000) : null
          }).then((result) => {

                this.events = this.compileList(result.body.result);    

          })

          //this.syncSelectedBets();
          setTimeout(() => {
            this.fetchLatestBets();
          }, 500);

          this.pagination = response.body.pagination;
          this.loader = false;
          this.eventNotfound = false;
          this.lockMatchUpdate = false;
          //this.$bus.$emit('globalLoader', 0);

        }, response => {
          // error callback
          //this.$bus.$emit('globalLoader', 0);
        })
      }

    },
    closeOdd() {
    },
    updateOdd(odd) {
      var change;

      change = null;

      if (this.changedOdd.id == odd.id) {
        change = (odd.odd > this.changedOdd.n) ? 'down' : 'up';
        odd.odd = this.changedOdd.n;
      }

      return change;
    },
    toggleMatch(match) {
      match.toggle = (match.toggle) ? false : true;
      //console.log(match.toggle);
    },
    getSportIco(vb) {
      //console.log(this.sportEmoji);
      return this.sportEmoji[vb];
    },
    totalShorts(outcome) {
      return (outcome == 'Over') ? '+' : '-';
    },
    checkSport(sportId) {
      if (this.$route.params.sport == 0) {
        return true;
      } else if (!this.$route.params.sport) {
        return true;
      } else {
        return (sportId == this.$route.params.sport) ? true : false;
      }
    },
    fixEvents(e) {
      var matches = new Array();
      this.sortAByKey(e, 'order').forEach((k, ev) => {

        if(typeof k.matches !== 'undefined'){
          Object.values(k.matches).forEach((m, mk) => {
            matches.push(m);
          });
        }

      });

      return matches;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.top-filter {
  float: left;
  padding: 0;
  margin: 0;
  width: 100%;
}
.top-filter li{
  float: left;
  list-style: none;
  font-size: 11px;
  line-height: 15px;
  background: rgba(0, 0, 0, 0.07);
  padding: 8px 20px;
  display: inline-block;
}
.top-filter li.right{
  float: right;
}
.top-filter li input{
  float: left;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/matches.vue